import React, { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { checkAuthStatus } from '../../services/authService';

const AuthCheck = ({ children }) => {
  const navigate = useNavigate();
  
  useEffect(() => {
    // Check auth status immediately
    const verifyAuth = async () => {
      try {
        const { isAuthenticated } = await checkAuthStatus();
        if (!isAuthenticated) {
          localStorage.removeItem('token');
          navigate('/home');
        }
      } catch (error) {
        console.error('Auth check failed:', error);
        localStorage.removeItem('token');
        navigate('/home');
      }
    };

    // Set up interval for periodic checks
    const intervalId = setInterval(verifyAuth, 30000); // 30 seconds

    // Initial check
    verifyAuth();

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [navigate]);

  return children;
};

const ProtectedRoute = ({ children, requireVerification = true }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userData, setUserData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const verifyAuth = async () => {
      try {
        const authStatus = await checkAuthStatus();
        setIsAuthenticated(authStatus.isAuthenticated);
        setUserData(authStatus.user || null);
        
        if (!authStatus.isAuthenticated) {
          localStorage.removeItem('token');
          navigate('/home');
        }
      } catch (error) {
        console.error('Authentication check failed:', error);
        setIsAuthenticated(false);
        localStorage.removeItem('token');
        navigate('/home');
      } finally {
        setIsLoading(false);
      }
    };

    verifyAuth();
  }, [navigate]);

  if (isLoading) {
    return <div>Loading...</div>; // Or a loading spinner
  }

  if (!isAuthenticated) {
    return <Navigate to="/home" replace />;
  }

  // If email verification is required and user is not verified
  if (requireVerification && userData && !userData.isEmailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  // Wrap children with AuthCheck for periodic authentication
  return <AuthCheck>{children}</AuthCheck>;
};

export default ProtectedRoute;